import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  READ_ORDER_REQUESTED,
  READ_ORDER_SUCCESS,
  READ_ORDER_FAILURE,
  CREATE_FULFILLMENT_REQUESTED,
  CREATE_FULFILLMENT_SUCCESS,
  CREATE_FULFILLMENT_FAILURE,
  CLEAR_ORDER,
  SET_CHECKED_LIST,
  SET_UNPICKABLE_LIST,
  // UPDATE_LINE_ITEM_QUANTITY_REQUESTED,
  // UPDATE_LINE_ITEM_QUANTITY_SUCCESS,
  // UPDATE_LINE_ITEM_QUANTITY_FAILURE,
} from '../types';


export const readOrderRequested = () => {
  return {
    type: READ_ORDER_REQUESTED
  }
};

export const readOrderSuccess = (payload) => {
  return {
    type: READ_ORDER_SUCCESS,
    payload: payload
  }
};

export const readOrderFailure = (error, orderId) => {
  return {
    type: READ_ORDER_FAILURE,
    error: `Could not read order ${orderId}`,
    status: error.response?.status,
    message: error.message,
  }
};

// export const indexFulfillmentStatusesRequested = () => {
//   return {
//     type: INDEX_FULFILLMENT_STATUSES_REQUESTED
//   }
// };

// export const indexFulfillmentStatusesSuccess = (payload) => {
//   return {
//     type: INDEX_FULFILLMENT_STATUSES_SUCCESS,
//     payload: payload
//   }
// };

// export const indexFulfillmentStatusesFailure = (error) => {
//   return {
//     type: INDEX_FULFILLMENT_STATUSES_FAILURE,
//     status: error.response?.status,
//     message: error.message,
//   }
// };


// export const updateFulfillmentStatusRequested = () => {
//   return {
//     type: UPDATE_ORDER_FULFILLMENT_STATUS_REQUESTED
//   }
// }

// export const updateFulfillmentStatusSuccess = (payload) => {
//   return {
//     type: UPDATE_ORDER_FULFILLMENT_STATUS_SUCCESS,
//     payload: payload
//   }
// }

// export const updateFulfillmentStatusFailure = (error) => {
//   return {
//     type: UPDATE_ORDER_FULFILLMENT_STATUS_FAILURE,
//     status: error.response?.status,
//     message: error.message,
//   }
// }

// export const updateLineItemQuantityRequested = () => {
//   return {
//     type: UPDATE_LINE_ITEM_QUANTITY_REQUESTED
//   }
// }

// export const updateLineItemQuantitySuccess = (payload) => {
//   return {
//     type: UPDATE_LINE_ITEM_QUANTITY_SUCCESS,
//     payload: payload
//   }
// }

// export const updateLineItemQuantityFailure = (error) => {
//   return {
//     type: UPDATE_LINE_ITEM_QUANTITY_FAILURE,
//     status: error.response?.status,
//     message: error.message,
//   }
// }



export const createFulfillmentRequested = () => {
  return {
    type: CREATE_FULFILLMENT_REQUESTED
  }
}

export const createFulfillmentSuccess = (payload) => {
  return {
    type: CREATE_FULFILLMENT_SUCCESS,
    payload: payload
  }
}

export const createFulfillmentFailure = (error) => {
  return {
    type: CREATE_FULFILLMENT_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
}

export const readOrder = (shopUrl, payload, orderId) => {
  return (dispatch) => {
    dispatch(readOrderRequested());

    let endPoint = Config.baseUrl + Config.order + '/' + orderId;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(readOrderSuccess(response.data));
      })
      .catch((error) => {
        dispatch(readOrderFailure(error, orderId));
      });
  }
}

export const createFulfillment = (shopUrl, payload, fulfillment) => {
  return (dispatch) => {
    dispatch(createFulfillmentRequested());

    let endPoint = Config.baseUrl + Config.fulfillment;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, { fulfillment: fulfillment }, { headers: headers })
      .then((response) => {
        dispatch(createFulfillmentSuccess(response.data));
      })
      .catch((error) => {
        dispatch(createFulfillmentFailure(error));
      })
  }
}

// export const updateLineItemQuantity = (shopUrl, payload, orderId, lineItemId, quantity) => {
//   return (dispatch) => {
//     dispatch(updateLineItemQuantityRequested());

//     let endPoint = Config.baseUrl + Config.orders + orderId;
//     let headers = Object.assign(Config.headers);
//     headers.payload = payload;
//     headers.shop = shopUrl;

//     return Axios.put(endPoint, { quantity: quantity, line_item_id: lineItemId } , { headers: headers })
//       .then((response) => {
//         if(response.data.status === 200) {
//           dispatch(updateLineItemQuantitySuccess(response.data));
//         } else {
//           dispatch(updateLineItemQuantityFailure());
//         }
//       })
//       .catch((error) => {
//         dispatch(updateLineItemQuantityFailure());
//       });
//   }
// }

export const setCheckedList = (checkedList) => {
  return (dispatch) => {
    dispatch({
      type: SET_CHECKED_LIST,
      checkedList: checkedList
    })
  }
}

export const setUnpickableList = (unpickableList) => {
  return (dispatch) => {
    dispatch({
      type: SET_UNPICKABLE_LIST,
      unpickableList: unpickableList
    })
  }
}

export const clearOrder = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_ORDER
    })
  }
}
